var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.7192,
    y: 20.5059,
    width: 30,
    height: 29,
    rx: 14.5,
    transform: "rotate(135 41.7192 20.5059)",
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4171 21.5663C16.0265 21.9569 16.0265 22.59 16.4171 22.9805L22.781 29.3445C23.1715 29.735 23.8047 29.735 24.1952 29.3445C24.5857 28.954 24.5858 28.3208 24.1952 27.9303L18.5384 22.2734L24.1952 16.6166C24.5858 16.2261 24.5858 15.5929 24.1953 15.2024C23.8047 14.8119 23.1716 14.8119 22.781 15.2024L16.4171 21.5663ZM17.5242 22.2734L17.5242 21.2734L17.1242 21.2734L17.1242 22.2734L17.1242 23.2734L17.5242 23.2734L17.5242 22.2734Z",
    fill: "#062A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowLeft);
export default __webpack_public_path__ + "static/media/slider-arrow-left.f48eea43ea325b1200c21ff7aa444f65.svg";
export { ForwardRef as ReactComponent };